import dayjs from 'dayjs';

export const parseValidDayjs = (value, { startOfDay = false, fallback = null } = {}) => {
  if (!value) return fallback;
  const parsed = startOfDay ? dayjs(value).startOf('day') : dayjs(value);
  return parsed.isValid() ? parsed : fallback;
};
